<!-- <form> -->
<!-- Modal Header -->
<div class="modal-header" [class]="checkType()">
  @if (alertType == enums.DANGER_ALERT) {
    <h4 class="modal-title">WARNING!</h4>
  }
  @if (alertType == enums.SUCCESS_ALERT) {
    <h4 class="modal-title">SUCCESS!</h4>
  }
  <!-- <button type="button" class="btn-close" data-dismiss="modal" tabindex=-1 (click)="closeDialog()"></button> -->
</div>

<div class="modal-body">
  <div class="container-fluid">
    <div class="p-3 messageText" [innerHTML]="processedMessage()"></div>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-outline-success" type="button" (click)="closeModal()">Okay</button>
</div>
<!-- </form> -->
